var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 32,
    viewBox: "0 0 32.001 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-settings",
    "data-name": "Icon ionic-md-settings",
    d: "M31.526,20.975a10.006,10.006,0,0,0,.082-1.6c0-.56-.082-1.04-.082-1.6l3.436-2.64a.735.735,0,0,0,.164-1.04l-3.273-5.52a.8.8,0,0,0-.982-.32l-4.091,1.6A11.909,11.909,0,0,0,24,8.255l-.573-4.24a.877.877,0,0,0-.818-.64H16.061a.877.877,0,0,0-.818.64l-.654,4.24a13.856,13.856,0,0,0-2.782,1.6l-4.091-1.6a.766.766,0,0,0-.982.32L3.46,14.1a.966.966,0,0,0,.164,1.04l3.519,2.64c0,.56-.082,1.04-.082,1.6s.082,1.04.082,1.6l-3.436,2.64a.735.735,0,0,0-.164,1.04l3.273,5.52a.8.8,0,0,0,.982.32l4.091-1.6a11.908,11.908,0,0,0,2.782,1.6l.654,4.24a.793.793,0,0,0,.818.64h6.546a.877.877,0,0,0,.818-.64l.655-4.24a13.848,13.848,0,0,0,2.782-1.6l4.091,1.6a.766.766,0,0,0,.982-.32l3.273-5.52a.965.965,0,0,0-.164-1.04Zm-12.192,4a5.6,5.6,0,1,1,0-11.2,5.6,5.6,0,1,1,0,11.2Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBSetting);
export default __webpack_public_path__ + "static/media/bSetting.24ccf74aa5e9acab69cf15d27fe98671.svg";
export { ForwardRef as ReactComponent };